"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypeTextMap = void 0;
const spu_1 = require("@tencent/tccp-frontend-contract/spu");
/** 产品三级形态 */
exports.ProductTypeTextMap = {
    /** IaaS */
    [spu_1.ProductTypeEnum.IaaS]: 'IaaS',
    /** PaaS */
    [spu_1.ProductTypeEnum.PaaS]: 'PaaS',
    /** SaaS */
    [spu_1.ProductTypeEnum.SaaS]: 'SaaS',
    /** 软件 */
    [spu_1.ProductTypeEnum.Software]: '软件',
    /** 硬件-服务器 */
    [spu_1.ProductTypeEnum.HardwareServer]: '硬件-服务器',
    /** 硬件-网络设备 */
    [spu_1.ProductTypeEnum.HardwareNet]: '硬件-网络设备',
    /** 硬件-其他 */
    [spu_1.ProductTypeEnum.HardwareOther]: '硬件-其他',
    /** 定开服务 */
    [spu_1.ProductTypeEnum.ServiceCustomDevelopment]: '定开服务',
    /** 运维服务 */
    [spu_1.ProductTypeEnum.ServiceOp]: '运维服务',
    /** 交付服务 */
    [spu_1.ProductTypeEnum.ServiceImplementation]: '交付服务',
    /** 教育内容 */
    [spu_1.ProductTypeEnum.EducationalContent]: '教育内容',
    /** 医疗内容 */
    [spu_1.ProductTypeEnum.MedicalContent]: '医疗内容',
    /** 维保服务 */
    [spu_1.ProductTypeEnum.ServiceProjectMaintenance]: '维保服务',
    /** 咨询服务 */
    [spu_1.ProductTypeEnum.ServiceConsulting]: '咨询服务',
    /** 培训服务 */
    [spu_1.ProductTypeEnum.ServiceTraining]: '培训服务',
    /** 其他 */
    [spu_1.ProductTypeEnum.Others]: '其他',
};
